import { MutationTree } from 'vuex';
import { ZoomSignatureState } from './state';

const mutations: MutationTree<ZoomSignatureState> = {
  SET_SIGNATURE(state, signature: string) {
    state.signature = signature;
  },
};

export default mutations;
